import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";

const Story = ({ storySection }) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <section className="flex flex-col gap-6 items-center justify-center bg-banner pb-10 px-4 lg:px-0">
      {/* Image Section with Animation */}
      <div
        className="flex items-center justify-center w-full"
        data-aos="fade-up"
      >
        <img
          src={storySection?.image?.url}
          alt="story section visual"
          className="w-full max-w-[1050px] h-auto lg:h-[465px] object-cover"
        />
      </div>

      {/* Text Section with Animation */}
      <div
        className="text-center max-w-screen-md px-4 lg:px-0 md:mx-0 mx-3"
        data-aos="fade-in"
        data-aos-delay="200"
      >
        <p className="text-[#F0FFC5] text-[16px] lg:text-[20px]">
          {storySection?.description ||
            "Our Comprehensive Inspection covers 3500+ Vehicle checkpoints, leaving no detail unchecked."}
        </p>
      </div>
    </section>
  );
};

export default Story;
